import { useEffect, useState } from 'react';
import { loadSubjects } from '../lib/subjects';

/**
 * useSubjects — returns { subjects, loaded }.
 * Subjects are fetched once and cached for the whole app.
 */
export function useSubjects() {
    const [subjects, setSubjects] = useState([]);
    const [loaded, setLoaded] = useState(false);
    useEffect(() => {
        let mounted = true;
        loadSubjects().then((s) => {
            if (mounted) {
                setSubjects(s);
                setLoaded(true);
            }
        });
        return () => { mounted = false; };
    }, []);
    return { subjects, loaded };
}
